import './App.css';
import UpcomingClasses from './components/UpcomingLiveClasses/UpcomingClasses';

function App() {
  return (
    <div className="App" >
      <UpcomingClasses/>
    </div>
  );
}

export default App;
